<template>
  <main class="relative">
    <div v-if="!submitted">
      <p class="text-black text-[1.4rem] md:text-[1.8rem] pb-[2.4rem]">
        {{ $t("Enter your new password.") }}
      </p>

      <InputField
        class="pb-[2.4rem]"
        v-model="newPassword"
        :label="$t('New password *')"
        :placeholder="$t('New password')"
        inputType="password"
        required
        ref="newPasswordField"
        :inputProps="{ autocomplete: 'new-password', name: 'new-password' }"
      />

      <InputField
        class="pb-[2.4rem]"
        v-model="repeatPassword"
        :label="$t('Repeat password *')"
        :placeholder="$t('Repeat password')"
        inputType="password"
        required
        ref="repeatPasswordField"
        :inputProps="{ autocomplete: 'new-password', name: 'repeat-password' }"
      />

      <div v-if="errorMessage" class="text-red-600 text-[1.4rem] mb-4">
        {{ errorMessage }}
      </div>

      <CustomButton :label="$t('Save password')" @click="submit" />
    </div>

    <div v-else>
      <AlertBanner
        type="success"
        :message="$t('Your password has been changed successfully.')"
      />
      <router-link to="/login" class="underline text-[1.4rem] md:text-[1.8rem]">
        {{ $t("Go to login") }}
      </router-link>
    </div>
  </main>
</template>

<script>
import { defineComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import InputField from "@/components/input/inputField.vue";
import CustomButton from "@/components/buttons/customButton.vue";
import AlertBanner from "@/components/feedback/AlertBanner.vue";
import { resetPassword } from "@/services/medkusApi/publiccustomersService";

export default defineComponent({
  name: "ResetPasswordView",
  components: {
    InputField,
    CustomButton,
    AlertBanner,
  },
  data() {
    return {
      newPassword: "",
      repeatPassword: "",
      errorMessage: "",
      submitted: false,
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    return { route, router };
  },
  methods: {
    async submit() {
      this.$refs.newPasswordField.updateValue({ target: { value: this.newPassword } });
      this.$refs.repeatPasswordField.updateValue({ target: { value: this.repeatPassword } });

      if (this.$refs.newPasswordField.isInvalid || this.$refs.repeatPasswordField.isInvalid) {
        return;
      }

      if (this.newPassword.length < 5) {
        this.errorMessage = this.$t("Password must be at least 5 characters.");
        return;
      }

      if (this.newPassword !== this.repeatPassword) {
        this.errorMessage = this.$t("Passwords do not match.");
        return;
      }

      this.errorMessage = "";

      const tokenParam = this.route.params.token;
      const token = Array.isArray(tokenParam) ? tokenParam[0] : tokenParam ?? "";

      try {
        const result = await resetPassword({ token, plainPassword: this.newPassword });
        if (result && result.ok === true) {
          this.submitted = true;
        } else {
          this.errorMessage = this.$t("The link has expired or is invalid. Please request a new one.");
        }
      } catch {
        this.errorMessage = this.$t("An error occurred. Please try again.");
      }
    },
  },
});
</script>
